export function LogoMark({ className = "w-9 h-9" }) {
  return (
    <img src="/favicon.svg" alt="zilnic" className={className} />
  );
}

export function Logo({ className = "h-8 w-auto" }) {
  return (
    <img
      src="/logo-navy.svg"
      alt="zilnic"
      className={className}
      data-testid="brand-logo"
    />
  );
}

export function LogoWhite({ className = "h-8 w-auto" }) {
  return <img src="/logo-white.svg" alt="zilnic" className={className} />;
}
